import { SystemConfigurationDto, SystemConfigurationService } from '@/api';

export default {
  getSystemConfiguration: async (): Promise<SystemConfigurationDto> => {
    const response = await SystemConfigurationService.systemConfigurationControllerGetSystemConfiguration();
    return response.data;
  },
};
